import RecaptchaTerms from '../src/RecaptchaTerms.tsx';
export default RecaptchaTerms;
